import { detect } from 'detect-browser';
const browser = detect();

export const isSafari = () => browser && browser.name === 'safari';
